import { createRouter, createWebHistory } from "vue-router"
import store from './store'
import {callApi, finallyCallApi} from '@/callApi'

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_ROUTER_BASE),
  routes: [
    {
      // チケット一覧
      path: '/',
      name: 'ticket_list',
      component: () => import(/* webpackChunkName: "ticket_list" */ './views/TicketList.vue')
    },{
      // チケット一覧
      path: '/history',
      name: 'history',
      // component: () => import(/* webpackChunkName: "ticket_list" */ './views/TicketList.vue'),
      beforeEnter: (to, from, next) => {
        store.commit('RouteParams/setParams', {
          history: '1'
        })
        next({name: 'ticket_list', replace: true})
        // next({name: 'ticket_list', params: { history: '1' }, replace: true})
        return
      },
      props: true,
    },{
      // QR発券
      path: '/qrcode',
      name: 'qrcode',
      component: () => import(/* webpackChunkName: "qrcode" */ './views/QRCode.vue'),
      props: true,
      meta: { requiresAuth: false }
    },{
      // 譲渡分配受取
      path: '/Receive',
      name: 'receive',
      component: () => import(/* webpackChunkName: "receive" */ './views/Receive.vue'),
      beforeEnter: (to, from, next) => {
        // queryからpropsに変換
        if(to.query.te){
          // queryパラメータをstoreに保存し譲渡分配受取ページへ遷移
          store.commit('RouteParams/setParams', {
            ticketEnckey: to.query.te
          })
          next({name: 'receive', replace: true})
          return
        }
        next()
      },
      props: true,
      meta: { requiresAuth: false }
    },{
      // ログインして受け取り
      path: '/Receive-auth',
      name: 'receive-auth',
      component: () => import(/* webpackChunkName: "receive-auth" */ './views/ReceiveAuth.vue'),
      props: true
    },{
      // リセール
      path: '/Resale',
      name: 'resale',
      component: () => import(/* webpackChunkName: "resale" */ './views/Resale.vue'),
      props: true,
    },{
      // リセール取消
      path: '/Resale-cancel',
      name: 'resale-cancel',
      component: () => import(/* webpackChunkName: "resale-cancel" */ './views/ResaleCancel.vue'),
      props: true,
    },{
      // リセール入金情報
      path: '/ResalePaymentInfo',
      name: 'resale_payment_info',
      component: () => import(/* webpackChunkName: "resale_payment_info" */ './views/ResalePaymentInfo.vue'),
      props: true,
    },{
      // リセール内容確認
      path: '/ResaleConfirm',
      name: 'resale_confirm',
      component: () => import(/* webpackChunkName: "resale_confirm" */ './views/ResaleConfirm.vue'),
      props: true,
    },{
      // リセール完了
      path: '/resale_complete',
      name: 'resale_complete',
      component: () => import(/* webpackChunkName: "resale_complete" */ './views/ResaleComplete.vue'),
      props: true,
    },{
      // 購入・抽選履歴詳細
      path: '/lphistory_detail',
      name: 'lphistory_detail',
      component: () => import(/* webpackChunkName: "receive-auth" */ './views/LotteryPurchaseHistoryDetail.vue'),
      props: true
    },{
      // 抽選申込取消完了
      path: '/lotterycancel_complete',
      name: 'lotterycancel_complete',
      component: () => import(/* webpackChunkName: "resale_complete" */ './views/LotteryCancelComplete.vue'),
      props: true,
    },{
      // 基本認証ログイン後遷移先
      path: '/redirect',
      name: 'redirect',
      beforeEnter: (to, from, next) => {
        if(to.query.error) return next(Error('Auth Error'))
        if(to.query.sid && to.query.sid != 2000) return next(Error('Bad Request'))
        if(to.query.sid && to.query.sid == 2000) return router.callJAuth()
        store.commit('RouteParams/setParams', {code: to.query.code, state: to.query.state})
        next({name: 'auth', replace: true})
      },
      meta: { requiresAuth: false }
    },{
      // 認証
      path: '/Auth',
      name: 'auth',
      component: () => import(/* webpackChunkName: "auth" */ './views/Auth.vue'),
      props: true,
      meta: { requiresAuth: false }
    },{
      // 不足情報案内画面
      path: '/Missing_info',
      name: 'missing_info',
      component: () => import(/* webpackChunkName: "auth" */ './views/MissingInfo.vue'),
      props: true
    },{
      // エラー
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ './views/Error.vue'),
      props: true,
      meta: { requiresAuth: false }
    },{
      // メンテナンス画面
      path: '/Maintenance',
      name: 'maintenance',
      component: () => import(/* webpackChunkName: "maintenance" */ './views/Maintenance.vue'),
      props: true,
      meta: { requiresAuth: false }
    },{
      // 不足情報入力用リダイレクト
      path: '/redirect2',
      name: 'redirect2',
      beforeEnter: (to, from, next) => {
        return router.backpage(to,from,next)        
      },
      meta: { requiresAuth: false }
    },{
      path: '/:pathMatch(.*)*',
      redirect: '/error'
    }
  ],
  // 画面遷移した場合はスクロールをTOPに戻します
  scrollBehavior() { return { top: 0, left: 0 } },
})
// 画面遷移時エラーハンドリング
router.onError(error => {
  console.error(`---onError ${error}`)
  router.replace({path: '/error'})
})
router.beforeEach((to, from, next) => {
  store.commit("Loading/isRouting", true)

  const data = sessionStorage.getItem(process.env.VUE_APP_SESSIONSTORAGE_RELOAD)
  sessionStorage.removeItem(process.env.VUE_APP_SESSIONSTORAGE_RELOAD)
  console.debug(`---- remove sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_RELOAD}]`)

  console.info(`==> url[${to.fullPath}]`
            + ` reqAuth[${to.meta.requiresAuth != false}]`
            + ` token[${store.state.Auth.token}]`
            + ` params[${JSON.stringify(to.params)}]`
            + ` sLogin[${sessionStorage.getItem(process.env.VUE_APP_SESSIONSTORAGE_LOGIN)}]`
            + ` sReload[${data}]`
            + ` naviType[${window.performance.navigation.type}]`)

  // リロードの場合storeを復元してpropありの元の画面へ遷移
  if(window.performance.navigation.type == 1 && data){
    store.commit('load', JSON.parse(data))
    const to = store.state.Loading.to
    store.commit('Loading/saveTo', undefined)
    console.debug(`---- store復元 sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_RELOAD}] ${data}`)
    // パラメータを復元する
    store.commit('RouteParams/setParams', to.params)
    // return next({...to, replace: true})
    return next({name: to.name, path: to.path, fullPath: to.fullPath,
      query: to.query, hash: to.hash, replace: true})
  }

  // 履歴から遷移された場合storeを復元
  if(window.performance.navigation.type == 2 && data){
    store.commit('load', JSON.parse(data))
    store.commit('Loading/saveTo', undefined)
    console.debug(`---- store復元 sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_RELOAD}] ${data}`)
  }

  // 認証済みもしくは認証不要なのでログイン不要
  if(store.state.Auth.user
  || (to.query.jfalogin != 1
  && to.matched.some(record => record.meta.requiresAuth == false))){
    next()
    return
  }

  // ログイン処理
  // --APIのトークン取得
  callApi('Auth/getToken')
    .then(response => {
      // JFA基盤認証から戻って来た時に必要な値を保存
      sessionStorage.setItem(process.env.VUE_APP_SESSIONSTORAGE_LOGIN, JSON.stringify({
        token: store.state.Auth.token,
        redirect: {name: to.name, path: to.path, fullPath: to.fullPath,
          params: to.params, query: to.query, hash: to.hash},
        state: response.data.appData.authInfo.state,
        nonce: response.data.appData.authInfo.nonce
      }))
      
      console.debug(`---- save sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_LOGIN}] `
        + `${sessionStorage.getItem(process.env.VUE_APP_SESSIONSTORAGE_LOGIN)}`)
      
      // --JFA基盤認証呼び出し
      router.callJAuth()
    }).catch(error=>{
      finallyCallApi(error, next)
      store.commit("Auth/clear")
    })
})

router.callJAuth = () =>{
   // 認証基盤遷移前に保存しておいた値を取得
   let loginInfo = sessionStorage.getItem(process.env.VUE_APP_SESSIONSTORAGE_LOGIN)
   if(loginInfo) loginInfo = JSON.parse(loginInfo)

   // 認証基盤遷移前に保存しておいた値が存在しないためエラー画面へ
   if(!loginInfo || !loginInfo.state || !loginInfo.nonce){
     throw Error('Bad Request')
   }

  var url = `${process.env.VUE_APP_AUTH_BASE_URL}${process.env.VUE_APP_AUTH_AUTHORIZE_URL}`
  url += `?response_type=${encodeURI(process.env.VUE_APP_AUTH_RESPONSE_TYPE)}`
  url += `&client_id=${encodeURI(process.env.VUE_APP_AUTH_CLIENT_ID)}`
  url += `&redirect_uri=${encodeURI(process.env.VUE_APP_AUTH_REDIRECT_URL)}`
  url += `&scope=${encodeURI(process.env.VUE_APP_AUTH_SCOPE)}`
  url += `&state=${encodeURI(loginInfo.state)}`
  url += `&nonce=${encodeURI(loginInfo.nonce)}`

  console.debug(`====> ${url}`)
  window.location.replace(url)
}

router.backpage = ((to, from, next) =>{

  const data = sessionStorage.getItem(process.env.VUE_APP_SESSIONSTORAGE_ATTRCHG)
  sessionStorage.removeItem(process.env.VUE_APP_SESSIONSTORAGE_ATTRCHG)
  console.debug(`---- remove sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_ATTRCHG}]`)

  // storeを復元して元の画面へ遷移
  if(data){
    store.commit('load', JSON.parse(data))
    const to = store.state.Loading.to
    store.commit('Loading/saveTo', undefined)
    console.debug(`---- store復元 sessionStorage[${process.env.VUE_APP_SESSIONSTORAGE_ATTRCHG}] ${data}`)
    
    // ハンバーガーメニューの「会員情報(変更、メルマガ登録、退会)から遷移かどうか判定をする
    if(store.state.Nav.menuMoveFlg == 1){
      // ハンバーガーメニューから遷移
      // フラグをクリアしてチケット一覧へ遷移
      store.commit('Nav/clearMenuMoveFlg')
      return next({name:'ticket_list', replace: true})
    }
    // パラメータを復元する
    store.commit('RouteParams/setParams', to.params)
    return next({name: to.name, path: to.path, fullPath: to.fullPath,
      query: to.query, hash: to.hash, replace: true})
    // return next({...to, replace: true})
  }else{
    return next(Error('Bad Request'))
  }
})

router.afterEach(to => {
  const params = store.state.RouteParams.params
  store.commit("RouteParams/clear")
  store.commit("Loading/saveTo", {name: to.name, path: to.path, fullPath: to.fullPath,
    params: params, query: to.query, hash: to.hash})
  store.commit("Loading/isRouting", false)
})

// // routerがabort(別画面に遷移)する場合に発生するエラーログを回避
// //  ・異常時はrouter.onErrorの処理が走るので動作としては問題ない
// //  ・abort時の動作を指定したい場合はpush(location, onComplete, onAbort)を利用する または
// //    この処理を削除してください。
// const originalPush = Router.prototype.push
// Router.prototype.push = function(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(() => {/*Uncaught (in promise) エラー回避*/})
// }

// const originalReplace = Router.prototype.replace
// Router.prototype.replace = function(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
//   return originalReplace.call(this, location).catch(() => {/*Uncaught (in promise) エラー回避*/})
// }
export default router